
import axios from "axios";
import Cookies from "js-cookie";

// 🧠 ایجاد instance اصلی axios
const api = axios.create({
  baseURL: "https://shop.irandap.com/api/api/troy/",
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ تابع برای ست کردن یا حذف توکن
export const setAuthToken = (token) => {
  if (token) {
    Cookies.set("authToken", token, { expires: 7, secure: false, sameSite: "Strict" });
  } else {
    Cookies.remove("authToken");
  }
};

// ✅ تابع برای گرفتن توکن از کوکی
export const getAuthToken = () => {
  return Cookies.get("authToken") || null;
};

// ✅ interceptor برای اضافه کردن Authorization
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken(); // همیشه جدیدترین مقدار را می‌گیرد
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ interceptor برای بررسی خطاهای 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    // اگر خطای 401 و غیر از لاگین باشد
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url !== "/login"
    ) {
      originalRequest._retry = true; // جلوگیری از لوپ بی‌نهایت

      console.warn("❌ توکن نامعتبر یا منقضی شده است");
      setAuthToken(null);

      // فقط redirect اگر کاربر در صفحات محافظت شده است
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default api;
